import { apiCreate, apiUpdate, apiGetList, apiGetOne } from './ApiBaseActions';
export const API_CREATE_PROFFIT_SEARCH_SLIDE = 'API_CREATE_PROFFIT_SEARCH_SLIDE';
export const API_CREATE_PROFFIT_SEARCH_SLIDE_UPLOAD_GROUP = 'API_CREATE_PROFFIT_SEARCH_SLIDE_UPLOAD_GROUP';
export const API_CREATE_PROFFIT_SEARCH_SLIDE_UPLOAD_GROUP_SUCCESS = 'API_CREATE_PROFFIT_SEARCH_SLIDE_UPLOAD_GROUP_SUCCESS';
export const API_GET_ONE_PROFFIT_SEARCH_SLIDE_UPLOAD_GROUP = 'API_GET_ONE_PROFFIT_SEARCH_SLIDE_UPLOAD_GROUP';
export const API_UPDATE_PROFFIT_SEARCH_SLIDE_UPLOAD_COMPLETE_VIEW_AT = 'API_UPDATE_PROFFIT_SEARCH_SLIDE_UPLOAD_COMPLETE_VIEW_AT';
export const API_GET_LIST_PROFFIT_SEARCH_SLIDE_HISTORY = 'API_GET_LIST_PROFFIT_SEARCH_SLIDE_HISTORY';
export const API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION = 'API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION';
export const API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION_SUCCESS = 'API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION_SUCCESS';
/**
 * スライドの登録
 * @param data
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiCreateProffitSearchSlide = (data, meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_SLIDE, '/proffit_search/slide', data, meta || {});
/**
 * スライドアップロードグループの作成
 * @param data
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiCreateProffitSearchSlideUploadGroup = (data, meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_SLIDE_UPLOAD_GROUP, '/proffit_search/slide_upload_group', data, meta || {});
/**
 * スライドアップロードグループの状態の取得
 * @param id
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiGetOneProffitSearchSlideUploadGroup = (id, meta) => apiGetOne(API_GET_ONE_PROFFIT_SEARCH_SLIDE_UPLOAD_GROUP, `/proffit_search/slide_upload_group/${id}`, meta || {});
/**
 * アップロード完了通知を既読に更新
 * @param data
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiUpdateProffitSearchSlideUploadCompleteViewAt = (data, meta) => apiUpdate(API_UPDATE_PROFFIT_SEARCH_SLIDE_UPLOAD_COMPLETE_VIEW_AT, '/proffit_search/update_upload_complete_view_at', data, meta || {});
/**
 * スライドの一覧の取得
 * @param data
 * @param meta
 * @returns {{payload: {params: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiGetListProffitSearchSlideHistory = (data, meta) => apiGetList(API_GET_LIST_PROFFIT_SEARCH_SLIDE_HISTORY, '/proffit_search/slide', data, meta || {});
/**
 * スライドの登録状態の取得
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetOneProffitSearchInformation = (meta) => apiGetOne(API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION, '/proffit_search/information', meta || {});
